<template>
  <div class="d-flex flex-column">
    <div
      class="d-flex align-center justify-space-between"
      style="min-height: 36px"
    >
      <table-name
        :table-number="tableNumber"
        :table-prefix="tablePrefix"
        :table-suffix="tableSuffix"
        :custom-name="customName"
        class="text-xs mb-1"
      />
      <!-- 卓の連結(子卓): 親卓名のチップ -->
      <v-chip
        v-if="childGroup"
        x-small
        dark
        :color="groupColor"
        class="ml-1"
      >
        <v-icon
          x-small
          left
        >
          {{ icons.mdiLinkVariant }}
        </v-icon>
        {{ parentTableName }}
      </v-chip>
    </div>

    <!-- 子卓: 「+」を出さず入店受付も開かない。タップで解除メニューだけ出す -->
    <v-menu
      v-if="childGroup"
      top
    >
      <template #activator="{ on, attrs }">
        <v-card
          class="flex-grow-1 elevation-4 d-flex flex-column align-center justify-center table-not-in-use--child"
          min-height="236.5"
          color="transparent"
          :ripple="false"
          :style="{ borderTop: `6px solid ${groupColor}`, color: groupColor }"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon
            large
            :color="groupColor"
          >
            {{ icons.mdiLinkVariant }}
          </v-icon>
          <span class="font-weight-semibold mt-2">{{ parentTableName }}と連結中</span>
        </v-card>
      </template>
      <v-list
        dense
        outlined
      >
        <v-subheader>{{ parentTableName }}と連結中</v-subheader>
        <v-list-item @click="$emit('unlink-table-group')">
          <v-list-item-title class="d-flex align-center">
            <v-icon
              small
              class="mr-2"
            >
              {{ icons.mdiLinkVariantOff }}
            </v-icon>
            <span>この卓の連結を解除</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-card
      v-else
      class="flex-grow-1 elevation-4 d-flex align-center justify-center"
      min-height="236.5"
      color="transparent"
      :disabled="table && table.hold"
      :ripple="false"
      @click="$emit('clicked')"
    >
      <beat-loader
        v-if="table && table.hold"
        :loading="true"
        :color="'#8A8D93'"
        size="10px"
      />
      <v-icon
        v-else
        large
      >
        {{ icons.mdiPlus }}
      </v-icon>
    </v-card>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import { mdiPlus, mdiLinkVariant, mdiLinkVariantOff } from '@mdi/js'
import BeatLoader from 'vue-spinner/src/BeatLoader.vue'
import TableName from '@/views/components/table/TableName.vue'
import { tableGroupColor } from '@/utils/tableGroupColors'

export default {
  components: {
    TableName,
    BeatLoader,
  },
  props: {
    tablePrefix: {
      type: String,
      default: '',
    },
    tableSuffix: {
      type: String,
      default: '卓',
    },
    tableNumber: {
      type: [String, Number],
      required: true,
    },
    customName: {
      type: String,
      default: '',
    },
    table: {
      type: [Object, undefined],
      default: undefined,
    },
    // 卓の連結: この空卓が子卓として属する現役グループ(JSONAPI data)。null なら通常の空卓
    childGroup: {
      type: Object,
      default: null,
    },
    // 親卓の表示名(カスタム卓名を含む。親側で解決して渡す)
    parentTableName: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const groupColor = computed(() => (props.childGroup ? tableGroupColor(props.childGroup.attributes.colorIndex) : ''))

    return {
      groupColor,
      icons: {
        mdiPlus,
        mdiLinkVariant,
        mdiLinkVariantOff,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.table-not-in-use--child {
  cursor: pointer;
}
</style>
